import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';

import { Subject } from 'rxjs';

import { CommonRegEx } from '@nrwl/common-lib';

import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'wizard-user-update',
  templateUrl: './user.update.html',
  providers: []
})
export class UserUpdateComponent implements IWizardContentComponent, OnInit, OnDestroy {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm') form: NgForm;

  emailRegEx: RegExp;
  firstName: string;
  lastName: string;
  email: string;

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(private readonly wizardService: UserWizardService) {}

  ngOnInit() {
    this.emailRegEx = CommonRegEx.EMAIL;
    this.wizardService.editMode = true;
    this.step.form = this.form;
    this.firstName = this.step.output.firstName;
    this.lastName = this.step.output.lastName !== '!REMOVED!' ? this.step.output.lastName : '';
    this.email = this.step.output.email;
  }

  firstNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'firstNameInput',
      key: 'firstName',
      newValue: this.firstName,
      isValid: this.form.controls.firstName.valid
    });
  }

  lastNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'lastNameInput',
      key: 'lastName',
      newValue: this.lastName,
      isValid: this.form.controls.lastName.valid
    });
  }

  emailUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'emailInput',
      key: 'email',
      newValue: this.email,
      isValid: this.form.controls.email.valid
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.wizardService.editMode = false;
  }
}
